module.exports = __webpack_public_path__ + "static/a15ebb70691b22c36c0e826be50eecc2c52263580137e1dc85e710fb50aa512c-eb2d60a5294ce652dff90561aef841e6.png";